import React from "react";
import Layout from "../layouts/GeneralLayout";
import MoveCompleted from "../screens/Booking/moveCompleted";

const MobileMoveCompleted = () => {
  return (
    <Layout>
      <MoveCompleted />
    </Layout>
  );
};

export default MobileMoveCompleted;
